import { cn } from "../../lib/utils";
import {
  IconAdjustmentsBolt,
  IconCloud,
  IconCurrencyDollar,
  IconEaseInOut,
  IconHeart,
  IconHelp,
  IconRouteAltLeft,
  IconUsers,
} from "@tabler/icons-react";

export function FeaturesSectionDemo() {
  const features = [
    {
      title: "Built for Everyone",
      description:
        "Built for engineers, developers, entrepreneurs, dreamers, thinkers and doers.",
      icon: <IconUsers />,
    },
    {
      title: "Ease of use",
      description: "Very Useful Yet very easy to use.",
      icon: <IconEaseInOut />,
    },
    {
      title: "Completely Free",
      description:
        "Our Non-existing prices allows everyone to take advantage of our AI app.",
      icon: <IconCurrencyDollar />,
    },
    {
      title: "Environmentally Friendly",
      description:
        "Our AI makes sure to make your business as environmentally friendly as possible.",
      icon: <IconCloud />,
    },
    {
      title: "Full Control",
      description:
        "You have full control over your project, and could guide the AI however you want",
      icon: <IconRouteAltLeft />,
    },
    {
      title: "Detailed Documentation",
      description:
        "Detailed Documentation to make sure you take full advantage of the app.",
      icon: <IconHelp />,
    },
    {
      title: "Easily adjustable",
      description:
        "You can adjust your project whenever you want, however you want.",
      icon: <IconAdjustmentsBolt />,
    },
    {
      title: "Life Changing",
      description:
        "Can turn your dreams, into reality with a push of a button.",
      icon: <IconHeart />,
    },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  relative z-10 py-10 max-w-7xl mx-auto">
      {features.map((feature, index) => (
        <Feature key={feature.title} {...feature} index={index} />
      ))}
    </div>
  );
}

const Feature = ({
  title,
  description,
  icon,
  index,
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
  index: number;
}) => {
  return (
    <div
      className={cn(
        "flex flex-col lg:border-r  py-10 relative group/feature dark:border-neutral-800",
        (index === 0 || index === 4) && "lg:border-l dark:border-neutral-800",
        index < 4 && "lg:border-b dark:border-neutral-800",
      )}
    >
      {index < 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-slate-200 dark:from-slate-800 to-transparent pointer-events-none" />
      )}
      {index >= 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-slate-200 dark:from-slate-800 to-transparent pointer-events-none" />
      )}
      <div className="mb-4 relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
        {icon}
      </div>
      <div className="text-lg font-bold mb-2 relative z-10 px-10">
        <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-blue-500 transition-all duration-200 origin-center" />
        <span className="group-hover/feature:translate-x-2 transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
          {title}
        </span>
      </div>
      <p className="text-sm text-neutral-600 dark:text-neutral-300 max-w-xs relative z-10 px-10">
        {description}
      </p>
    </div>
  );
};
